export const contractStatusColor = {
  STARTED: '#5786FF',
  ACTIVE: '#FC65FF',
  CANCELLED: '#ff0000',
  FINISHED: '#ff0000'
};
